/** Attendance status options */
export const ATTENDANCE_STATUSES = ['present', 'absent', 'leave'] as const

/** Student prefixes (Thai) */
export const STUDENT_PREFIXES = ['ด.ช.', 'ด.ญ.'] as const

/** Guardian relationship types */
export const GUARDIAN_RELATIONSHIPS = ['พ่อ', 'แม่', 'ปู่', 'ย่า', 'ตา', 'ยาย', 'อื่นๆ'] as const

/** Homework subjects */
export const SUBJECTS = [
  'ภาษาไทย',
  'คณิตศาสตร์',
  'วิทยาศาสตร์',
  'สังคมศึกษา',
  'ภาษาอังกฤษ',
  'ศิลปะ',
  'สุขศึกษา',
  'การงานอาชีพ',
  'อื่นๆ',
] as const

/** Orientation item categories */
export const ORIENTATION_CATEGORIES = ['เอกสาร', 'อุปกรณ์', 'เครื่องแบบ'] as const

/** School info */
export const SCHOOL_NAME = 'โรงเรียนเมืองเลย'
export const GRADE_LEVELS = ['ป.3', 'ป.4'] as const

/** LINE green color */
export const LINE_GREEN = '#06C755'
